(ns app.front.init
  (:require [app.front.root :as root]
            [app.front.routes :as routes]
            [app.front.view.login :as login]
            [core.front.init :as init]))


(defn after-load []
  (init/init routes/routes root/root-view login/after-login-events))

(after-load)
